import React from "react";
import "../../index.css";
import "./auth-form-card.css";
import BrandLogo from "components/brand-logo/BrandLogo";

interface Props {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  footer?: string;
}

/**
 * Shared shell for every auth page (login, change-password, …).
 * Renders the centred card with brand logo, heading, and footer.
 * Pass an <AuthForm> or any content as children.
 */
function AuthFormCard({
  title,
  subtitle,
  children,
  footer = "© 2026 gardioPay · Kea Valley",
}: Props) {
  return (
    <div className="v1-auth-shell">
      <div className="v1-auth-card">
        <BrandLogo />
        <h1 className="v1-auth-title">{title}</h1>
        <p className="v1-auth-subtitle">{subtitle}</p>
        {children}
        <p className="v1-auth-footer">{footer}</p>
      </div>
    </div>
  );
}

export default AuthFormCard;
